import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgDeferredErrorVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgDeferredErrorVO.validationSchema()
  );

  constructor(readonly value: RoomBrandBgDeferredError) {
    JsonSchemaValidator.assert(RoomBrandBgDeferredErrorVO.validation, value);
  }

  toString() {
    return `${this.value.message} (${this.value.code}, ${this.value.errorId})`;
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["code", "message"],
      properties: {
        code: {
          type: "number",
          minimum: 0,
          maximum: Number.MAX_SAFE_INTEGER
        },
        message: {
          type: "string",
          minLength: 0,
          maxLength: 2_048
        },
        errorId: {
          type: "string",
          format: "uuid"
        }
      }
    };
  }
}

interface RoomBrandBgDeferredError {
  code: number;
  message: string;
  errorId?: string;
}
